export function useTitle(title: string, showCompanyName = true) {
  if (!showCompanyName) document.title = title
  else document.title = `${title} - ${process.env.REACT_APP_COMPANY}`
}
